import type { BlogListResponse, ContactRequest, ContactResponse } from './types';
import { ApiClientError } from './types';

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(path, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...init?.headers,
    },
  });

  if (!response.ok) {
    let message = `Error ${response.status}`;
    try {
      const body = (await response.json()) as { error?: string };
      if (body.error) message = body.error;
    } catch {
      // ignore parse errors
    }
    throw new ApiClientError(message, response.status);
  }

  return response.json() as Promise<T>;
}

export function listBlogArticles(): Promise<BlogListResponse> {
  return request<BlogListResponse>('/api/blog');
}

export function sendContactMessage(payload: ContactRequest): Promise<ContactResponse> {
  return request<ContactResponse>('/api/contact', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
